import '@/commons';
import Vue from 'vue';
import { onMounted, ref } from '@vue/composition-api';
import { Debug } from '@/shared/utils/helpers';
import vuetify from '@/config/plugins/vuetify';
import Footer from '@/layout/footer';
import Menu from '@/layout/menu';
import Carga from '@/layout/carga';
import { toggles } from '@/observable';
import 'intersection-observer';
import Scrollama from 'vue-scrollama';
import { clearScreenDown } from 'readline';

const footer = Footer;
const menu = Menu;
const carga = Carga;

const Nosotros = Vue.extend({
  components: {Scrollama},
  setup() {
    const beazul = ref(true);
    const toggleMenu = () => {
      toggles.menu = !toggles.menu;
    };
    const currStep = ref('');
    const currStep1 = ref('');
    const change = ref(false);
    const down = ref(false);
    const reorder = ref(false);
    const down1 = ref(false);
    const pasos1 = ({ element }: any) => {
      if (element.dataset.stepNo === '3') {
        reorder.value = !reorder.value;
      }
    };
    const pasos = ({ element }: any) => {
      if (element.dataset.stepNo === '20') {
        change.value = true;
        down.value = true;
      } else if (down.value === true && (element.dataset.stepNo === 'experiencia' || element.dataset.stepNo === 'innovación')) {
        down.value = false;
        setTimeout(() => {
          currStep.value = element.dataset.stepNo;
        }, 50);
        setTimeout(() => {
          change.value = !change.value;
        }, 80);
      } else {
        down.value = false;
        change.value = !change.value;
        setTimeout(() => {
          currStep.value = element.dataset.stepNo;
        }, 50);
        setTimeout(() => {
          change.value = !change.value;
        }, 80);
      }
    };
    onMounted(() => {
      setTimeout(() => {
        beazul.value = !beazul.value;
        AOS.init();
      }, 2800);
      setTimeout(() => {
        toggles.listo = !toggles.listo;
      }, 2000);
    });
    return {
      toggleMenu,
      beazul,
      currStep,
      pasos,
      change,
      currStep1,
      pasos1,
      reorder,
    };
  },
});
export default new Nosotros({
  el: '#nosotros',
  vuetify,
  delimiters: ['[{', '}]'],
});
